import { computed, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SpinerService {
  hideIfActive() {
    if (this.activeRequests() > 0) {
      this.reset();
    }
  }
  private activeRequests = signal(0);
  readonly loading = computed(() => this.activeRequests() > 0);

  show() {
    this.activeRequests.update((count) => count + 1);
    // this.activeRequests.update((v) => {
    //   console.log('SHOW', v + 1);
    //   console.trace();
    //   return v + 1;
    // });
  }

  hide() {
    // this.activeRequests.update((v) => {
    //   console.trace();
    //   console.log('HIDE', Math.max(0, v - 1));
    //   return Math.max(0, v - 1);
    // });
    this.activeRequests.update((count) => Math.max(count - 1, 0));
  }
  reset() {
    this.activeRequests.set(0);
  }
}
